import useCategoriesTree from '../../brand/queries/useCategoriesTree';
import useContentAvailableCheck from '../../core/hooks/useContentAvailableCheck';
import useCategory from '../../core/queries/useCategory';

const useIsBicycleCategory = () => {
    const { available: isIcStore } = useContentAvailableCheck({
        stores: 'ic',
    });

    const category = useCategory();

    const { tree, loading: categoriesLoading } = useCategoriesTree();

    const isBicycle =
        tree.findIndex(
            mainCategory => mainCategory.id === category.categoryAncestryIds[0]
        ) === 0;

    const isBicycleCategory = isIcStore && isBicycle;

    const loading = categoriesLoading || category.categoryLoading;

    return {
        isBicycleCategory,
        loading: loading && isIcStore,
    };
};

export default useIsBicycleCategory;
